import { elegir } from '../ui/layout-variant.tsx';
import { ProgresoMobile } from './Progreso.mobile.tsx';
import { ProgresoDesktop } from './Progreso.desktop.tsx';

export default elegir(ProgresoMobile, ProgresoDesktop);
